/**
 * Colours for generated PDF documents — invoices, quotes, service history
 * and diagnostic reports.
 *
 * A PDF is printed, emailed and archived; it is not themed, and
 * @react-pdf/renderer cannot read CSS variables. So these are the one place
 * literal colours belong outside styles/theme.css, and every document shares
 * them, so a fix lands on all four at once.
 *
 * Contrast is measured on white. Tailwind's gray-400 (#9CA3AF) is 2.8:1 —
 * below the 4.5:1 body text needs — and was the reason the printed invoice
 * was reported as hard to read. The invoice was fixed; quotes, service
 * history and diagnostic reports kept the old grey until they moved here.
 */
export const DOC = {
    black: '#111827',
    dark: '#1F2937',
    body: '#374151',
    muted: '#4B5563',       // 7.0:1
    label: '#6B7280',       // 4.8:1
    line: '#E5E7EB',
    faintLine: '#F3F4F6',
    bg: '#F9FAFB',
    white: '#FFFFFF',
    green: '#16A34A',
    /* Severity on a diagnostic report — always printed beside the word, so
       it survives a mono printer and red/green colour blindness. */
    urgent: '#B91C1C',
    advisory: '#B45309',
    ok: '#047857',
} as const;
